<template>
  <v-responsive :aspect-ratio="16/9" class="rounded">
    <iframe
      v-if="videoId"
      :src="`https://www.youtube.com/embed/${videoId}`"
      frameborder="0"
      allowfullscreen
      style="width: 100%; height: 100%; border: 0;"
    ></iframe>
    <div v-else class="text-white flex items-center justify-center h-full">無法顯示影片</div>
  </v-responsive>
</template>

<script>
export default {
  name: 'YoutubeIframe',
  props: {
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    videoId() {
      const url = this.url.trim();
      const watchMatch = url.match(/[?&]v=([\w-]{11})/);
      return watchMatch?.[1] || '';
    }
  }
};
</script>
